module.exports = __webpack_public_path__ + "img/IMG_VacheCompletFichier 48Simulateur.ca426834.png";